import React from "react";
import styled from "styled-components";
import {
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
  TableBody,
  Table,
} from "semantic-ui-react";
import { useScreenWidth } from "../../../helper/screentWidth";
import Information from "../../Common/Information";
import { ConvertTime, Number } from "../../../helper/functions";

function Card({ Title, BackgroundColor, Icon, accounts }) {
  const width = useScreenWidth();
  return (
    <SubContainer BackgroundColor={BackgroundColor}>
      <TopPart>
        <SubTitle>
          <img src={Icon} /> {Title}
        </SubTitle>
      </TopPart>
      <BottomPart>
        {width > 765 ? (
          <CustomTable celled fixed>
            <TableHeader>
              <TableRow>
                <CustomHeader>Number</CustomHeader>
                <CustomHeader>Account Use</CustomHeader>
                <CustomHeader>Custodian</CustomHeader>
                <CustomHeader>Balance</CustomHeader>
                <CustomHeader>Balance as of</CustomHeader>
              </TableRow>
            </TableHeader>
            <CustomBody>
              {accounts.map((data) => {
                return (
                  <>
                    <CustomTableRow>
                      <TableCell>{data.hfa_number}</TableCell>
                      <TableCell>
                        {
                          data[
                            "_hip_accountuselookup_value@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                      </TableCell>
                      <TableCell>
                        {
                          data[
                            "_hip_custodian_value@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                      </TableCell>
                      <Table.Cell>
                        {data.hfa_balance === null
                          ? ""
                          : "$" + Number(data.hfa_balance)}
                      </Table.Cell>
                      <Table.Cell>
                        {
                          data[
                            "hip_balanceupdatedon@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                      </Table.Cell>
                    </CustomTableRow>
                  </>
                );
              })}
            </CustomBody>
          </CustomTable>
        ) : (
          <>
            {accounts.map((data) => {
              return (
                <>
                  <Information
                    bodyColor="#FFFFFF"
                    header={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ color: "#64C1C6" }}>Number:</span>
                        <span>{data.hfa_number}</span>
                      </div>
                    }
                    body={
                      <dl
                        style={{
                          display: "grid",
                          gridTemplateColumns: "auto 1fr",
                          gap: "10px 20px",
                          maxWidth: "400px",
                        }}
                      >
                        <CustomDt>Account Use:</CustomDt>
                        <dd>
                          {" "}
                          {
                            data[
                              "_hip_accountuselookup_value@OData.Community.Display.V1.FormattedValue"
                            ]
                          }
                        </dd>
                        <CustomDt>Custodian:</CustomDt>
                        <dd>
                          {" "}
                          {
                            data[
                              "_hip_custodian_value@OData.Community.Display.V1.FormattedValue"
                            ]
                          }
                        </dd>
                        <CustomDt>Balance:</CustomDt>
                        <dd>
                          {data.hfa_balance === null
                            ? ""
                            : "$" + Number(data.hfa_balance)}
                        </dd>
                        <CustomDt>Balance as of:</CustomDt>
                        <dd>
                          {
                            data[
                              "hip_balanceupdatedon@OData.Community.Display.V1.FormattedValue"
                            ]
                          }
                        </dd>
                          </dl>
                    }
                  />
                </>
              );
            })}
          </>
        )}
      </BottomPart>
    </SubContainer>
  );
}

const SubContainer = styled.div`
  display: grid;
  padding: 20px 0px;
  grid-template-columns: 1fr;
  gap: 10px;
  box-sizing: content-box !important;
  border-radius: 20px;
  box-shadow: 0px 0px 3px 0.1px gray;
  background: ${(props) =>
    props.BackgroundColor ? props.BackgroundColor : "#D4EEF0"};
`;

const TopPart = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 15px;
`;

const SubTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 30px;
  font-weight: 400;
`;

const Details = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  text-decoration: underline;
`;
const BottomPart = styled.div`
  padding: 0px 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;
`;

const CustomTable = styled(Table)`
  border: none !important;
  border-collapse: collapse !important;
`;

const CustomBody = styled(TableBody)`
  background: linear-gradient(
    180deg,
    rgba(251, 198, 125, 0.5) 0%,
    rgba(251, 198, 125, 0) 100%
  ) !important;
`;

const CustomTableRow = styled(TableRow)`
  background-color: white;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 24.102px; /* 172.156% */
  letter-spacing: -0.28px;

  &:nth-child(even) {
    background-color: #f0f9fa;
  }
`;
const CustomHeader = styled(TableHeaderCell)`
  background: #d4eef0 !important;
  border-top: none !important;
  border-bottom: none !important;

  color: #304961 !important;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24.102px; /* 150.637% */
  letter-spacing: -0.32px;
`;

const CustomDt = styled.dt`
  color: "#304961";
  font-weight: 600;
`;

export default Card;
